var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":_vm.botUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }